export default {
    buttons: {
        lecture: 'Cùng giáo viên',
        self: 'Tự học',
    },
    moduleLabel: {
        cardWriting: 'Viết thẻ 💬️',
        wordCheck: 'Thám tử từ',
        wordWriting: 'Chính tả',
        wordSelection: 'Chọn từ',
        seedLetter: 'Chữ cơ bản',
        oxQuiz: 'Câu đố OX',
        fillInTheBlanks: 'Điền vào chỗ trống',
        proConDebate: 'Tranh luận',
        segmentedReading: 'Đọc có hướng dẫn',
        sentenceOrdering: 'Sắp xếp câu',
        correctTheMistakes: 'Sửa lỗi',
        postIt: 'Hoàn thành bảng',
        magicWordTest: 'Biết! Không biết?',
    },
};
